import React, { useState, useEffect } from 'react';
import loadable from '@loadable/component';

import { WordCloud, WordCloudChildren, Link } from '@hpstellar/core';
import { Chat } from '@hpstellar/icons';

import withPageComponents from '../with-page-components';
import { Helpers } from '../../../core/src/helpers';
import useDisclaimerTabs from '../../../hooks/useDisclaimerTabs';

const FootnotesDisclaimer = loadable(() =>
    Helpers.retryFunc(() => import('../../../pdp/components-v2/footnotes-disclaimer')),
);
const hasDisclaimers = pdpFootnotesDisclaimer => {
    //if pdpFootnotesDisclaimer is not present or if all disclaimerPoints are empty, return false
    return (
        pdpFootnotesDisclaimer &&
        pdpFootnotesDisclaimer.length > 0 &&
        !pdpFootnotesDisclaimer.every(disclaimer => !disclaimer.disclaimerPoints.length)
    );
};

import DisclaimerList from '../disclaimer-list';
import './disclaimer-tabs.less';

export const FeedbackButton = (children, isDesktop) => {
    const id = 'feedBackButton';

    const proxyClick = () => {
        document.getElementById('nebula_div_btn')?.click();
    };
    const style = {
        height: 60,
        padding: '0 16px',
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
    };
    return (
        <>
            <div style={style}>
                <Chat size="m" />
                <span style={{ marginLeft: 8 }} />
                <Link isFixed id={id} color="dark" variation="primary" onClick={proxyClick} dense>
                    Feedback
                </Link>
            </div>
            {children}
        </>
    );
};

export default withPageComponents(
    ({ wordCloud, pdpFootnotesDisclaimer, moreAboutProducts, footerDisclaimer, device }) => {
        let tabs = [];
        let contents = [];
        let { wcLinks, wcTabs } = wordCloud || {};
        const [localIndex, setActiveIndex] = useState(null);
        /** check for disclaimer state from external sources */
        const [disclaimerTab, setDisclaimerTab] = useDisclaimerTabs();
        const activeIndex = disclaimerTab === 'product' ? 0 : localIndex;
        const [linksActiveIndex, setLinksActiveIndex] = useState(0);
        const customHtml =
            !footerDisclaimer || footerDisclaimer.customHtml === ''
                ? null
                : footerDisclaimer.customHtml || footerDisclaimer;
        useEffect(() => {
            if (pdpFootnotesDisclaimer && activeIndex == undefined) {
                setActiveIndex(pdpFootnotesDisclaimer ? 0 : null);
            }
        }, [pdpFootnotesDisclaimer]);

        if (hasDisclaimers(pdpFootnotesDisclaimer)) {
            tabs.push('Product Disclaimers');
            contents.push(
                <FootnotesDisclaimer
                    className="product-disclaimer-section"
                    title={null}
                    pdpFootnotesDisclaimer={pdpFootnotesDisclaimer}
                    accordionProps={{ isStatic: true }}
                />,
            );
        }
        if (Array.isArray(wcLinks)) {
            tabs.push('More Useful Links');
            contents.push(
                <WordCloudChildren.WordCloudSEOLinks
                    key="wordCloud"
                    className="word-cloud-links"
                    title={'Browse helpful links by categories'}
                    activeIndex={linksActiveIndex}
                    onChangeTab={setLinksActiveIndex}
                    tabs={wcTabs}
                    data={wcLinks}
                />,
            );
        }

        if (
            moreAboutProducts &&
            moreAboutProducts.htmlContent &&
            !(Array.isArray(moreAboutProducts.deviceExclusion) && moreAboutProducts.deviceExclusion.includes(device))
        ) {
            const { title = 'More About These Products', htmlContent } = moreAboutProducts;
            tabs.push(title);
            contents.push(
                <DisclaimerList
                    key="productDisclaimer"
                    customHtml={htmlContent}
                    useRichContent={moreAboutProducts.useRichContent}
                />,
            );
        }

        // disclaimer contents
        tabs.push('Site Disclaimers');
        contents.push(<DisclaimerList key="disclaimer" customHtml={customHtml} />);

        return (
            <div className="wordcloud-container disclaimer-tabs" id="disclaimerTabs">
                <div className="tabs-title">
                    <WordCloud
                        activeIndex={activeIndex}
                        onChangeTab={index => {
                            if (index === activeIndex) {
                                setActiveIndex(null);
                                return;
                            }
                            setActiveIndex(index);
                            //always resest global state when disclaimer tab is clicked
                            setDisclaimerTab(null);
                        }}
                        renderHeader={FeedbackButton}
                        tabs={tabs}
                    >
                        {contents}
                    </WordCloud>
                </div>
            </div>
        );
    },
    {
        device: true,
        components: ['pdpFootnotesDisclaimer', 'moreAboutProducts', 'footerDisclaimer'],
    },
);
